export default __webpack_public_path__ + "static/safety-app-og-9784a1af24d3e535b4f44a5bd049b003.png";